/**
 * Calcula el descuento (en céntimos) de una promoción para un servicio concreto.
 *
 * importeAplicado viene del backend en EUROS.
 * El resultado se devuelve en CÉNTIMOS para poder restarse de precios en céntimos.
 *
 * @param {number} importeAplicado  Descuento total de la promoción (euros, desde BD)
 * @param {object} options
 * @param {boolean} options.esCifra        true si la promo es de tipo cifra (reparto equitativo)
 * @param {number}  options.numServicios   nº de servicios entre los que repartir (solo cifra)
 * @param {number}  options.proporcion     peso del servicio sobre el total (solo porcentaje)
 * @returns {number} descuento en céntimos
 */
export const calcularDescuentoServicioCentimos = (importeAplicado, { esCifra, numServicios = 1, proporcion = 1 } = {}) => {
    const base = parseFloat(importeAplicado || 0) * 100; // euros → céntimos
    return esCifra
        ? base / numServicios
        : base * proporcion;
};
